<template>
  <v-col cols="12" md="6">
    <!-- Pin -->
    <OfferPin @pin-click="pinOffer" :saved="saved" />

    <!-- Card oferta trabajo -->
    <v-card
      class="offer-card"
      :class="{
        'offer-card--featured': featured
      }"
      :to="`/offer/${offer.slug}`"
      tile
    >
      <div class="d-flex align-center">
        <!-- Organization logo -->
        <v-img class="offer-card__logo shrink" contain :src="logo" />

        <span class="offer-card__content d-flex flex-column align-items-left">
          <!-- Flag & Organization name -->
          <div>
            <img class="offer-card__flag" :src="getFlag(offer.city)"/>
            <span class="offer-card__organization">{{ offer.organization.name }}</span>
          </div>

          <!-- Offer title -->
          <div class="offer-card__title">
            {{ offer.title }}
          </div>

          <!-- Salary & date details -->
          <div class="offer-card__details d-flex flex-column flex-md-row align-left align-md-center">
            <span v-if="!offer.salary.hidden" class="d-md-none">{{ offer.salary.currency }} {{ salary[0] }} a {{ salary[1] }}</span>
            <span>Postula hasta el {{ offer.validity.end }}</span>
            <v-tooltip v-if="!offer.salary.hidden" top class="ma-0">
              <template v-slot:activator="{ on, attrs }">
                <img
                  class="offer-card__salary-icon d-none d-md-inline ml-2"
                  src="@/assets/icons/dinero.svg"
                  :alt="`Rango de salario: ${ offer.salary.currency } ${ salary[0] } a ${ salary[1] }`"
                  v-bind="attrs"
                  v-on="on"
                >
              </template>
              <span class="benefits__text" v-if="!offer.salary.hidden">
                {{ offer.salary.currency }} {{ salary[0] }} a {{ salary[1] }}
              </span>
            </v-tooltip>
          </div>

          <div class="d-flex">
            <!-- Work conditions -->
            <div class="offer-card__conditions conditions d-flex flex-nowrap">
              <div
                class="conditions__item d-flex align-center"
                v-for="condition in workingConditions"
                :key="condition.value"
              >
                <img
                  class="conditions__icon"
                  :src="require(`@/assets/icons/${ condition.icon }`)"
                />
                <span class="conditions__text mr-2">
                  {{ condition.value }}
                </span>
              </div>
              <div
                class="conditions__item d-flex align-center"
              >
                <img
                  class="conditions__icon"
                  :src="require(`@/assets/icons/${ workingModeIcon }`)"
                />
                <span class="conditions__text">
                  {{ offer.workingMode }}
                </span>
              </div>
            </div>
          </div>
        </span>

        <v-spacer class="d-none d-md-flex" />

        <!-- Benefits [MD+] -->
        <div class="d-none d-md-flex flex-column align-self-end">
          <div class="benefits d-flex flex-row-reverse">
            <v-avatar
              class="benefits__icon"
              v-for="(benefit, index) in benefits.desktop"
              :key="index"
              size="25"
              tile
            >
              <v-tooltip top class="ma-0">
                <template v-slot:activator="{ on, attrs }">
                  <img
                    v-if="offer && offer.benefits"
                    v-bind="attrs"
                    v-on="on"
                    :src="benefit.src"
                  />
                </template>
                <span class="offer-card__benefit-text">
                  {{ benefit.name ? benefit.name : benefit }}
                </span>
              </v-tooltip>
            </v-avatar>
          </div>
        </div>
      </div>
    </v-card>

    <!-- Ad "publica tu pega" -->
    <v-card
      v-if="publishCard && !this.saved"
      class="ad-card card-offer-pcs mt-6 mb-8 pa-6"
      @mouseleave="over = false; overBtn = false"
      :to="{name: 'OfferPost', params: {followFlow: true}}"
    >
      <v-row>
        <v-col cols="2" class="py-0 d-none d-md-block">
          <v-list-item-avatar size="90" color="white" class="ma-0 pa-0">
            <v-img style="background-color: #FFFFF !important;" contain max-width="65" max-height="90" :src="require('@/assets/images/logo-tcs.webp')"></v-img>
          </v-list-item-avatar>
        </v-col>
        <v-col cols="10" class="px-2 py-0 pa-sm-0">
          <v-list-item-content class="d-flex justify-start">
            <div class="ad-card__overline sub-title-card d-flex">
              PEGAS CON SENTIDO
            </div>
            <v-list-item-title class="ad-card__title title-card d-flex">
              Publica aquí tu oferta laboral
            </v-list-item-title>
          </v-list-item-content>
        </v-col>
      </v-row>
    </v-card>

    <v-snackbar
      v-model="snackbar.status"
      :color="snackbar.color"
      :timeout="snackbar.timeout"
    >
      {{snackbar.text}}
      <template v-slot:action="{ attrs }">
        <v-btn
          text
          v-bind="attrs"
          @click="snackbar.status = false"
        >
          Cerrar
        </v-btn>
      </template>
    </v-snackbar>
  </v-col>
</template>

<script>
import { datetime, currentImg, tools } from "@/libs/mixins";
import OfferPin from "@/components/OfferPin";

export default {
    name: "OfferCard",

    components: {
        OfferPin,
    },

    mixins: [datetime, currentImg, tools],

    props: {
        offer: {
            type: Object,
            required: true,
        },
        index: null,
        featured: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            snackbar: {
                status: false,
                text: "",
                timeout: 2000,
                color: "success",
            },
            over: false,
            overBtn: false,
            saved: false,
            publishCard: false,
            goalsToShow: [],
            salary: [],
            icons: [],
        };
    },

    created() {
        let pinnedOffers = JSON.parse(localStorage.getItem("offerSave"));
        this.saved = pinnedOffers && pinnedOffers.includes(this.offer.id) ? true : false;
        this.publishCard = this.index === 3 && location.pathname === "/offers";
        this.goalsToShow = this.offer.organization.goals.slice(0, 4);
        this.salary = this.offer.salary.hidden ? [] : this.formatterSalary(this.offer.salary).range;
    },

    computed: {
        benefits() {
            let benefits = this.offer.benefits.map(benefit => ({
                name: benefit,
                src: this.getBenefits(benefit.name ? benefit.name : benefit)
            }));
            return {
                mobile: benefits.slice(0, 3),
                desktop: benefits,
            };
        },
        workingModeIcon() {
            return `${ this.offer.workingMode.toLowerCase().replace(" ", "_").replace("-", "_") }.svg`;
        },
        workingConditions() {
            let { city, workingDay } = this.offer;
            return [
                {
                    value: this.getCountry,
                    icon: "place-localizer.svg",
                },
                {
                    value: workingDay,
                    icon: "event.svg",
                },
            ];
        },
        getCountry() {
            const city = this.offer.city;
            if (city === "Latinoamérica") return "Latinoamérica";
            return city ? city.substring(0, city.indexOf("(") - 1) : "";
        },
    },

    methods: {
        changeColor() {
            this.over = !this.over;
            this.overBtn = !this.overBtn;
        },
        pinOffer() {
            this.saved = !this.saved;
            let offerId = this.offer.id;
            let offers = JSON.parse(localStorage.getItem("offerSave"));

            if (!offers) offers = [];
            if (this.saved) {
                if (!offers.includes(offerId)) {
                    offers.push(offerId);
                    localStorage.setItem("offerSave", JSON.stringify(offers));
                }
            } else {
                offers.splice(offers.indexOf(offerId), 1);
                localStorage.setItem("offerSave", JSON.stringify(offers));
            }
            this.$emit("get-offers");
        },
        copy(value) {
            if (value) {
                const el = document.createElement("textarea");
                el.value = value;
                el.setAttribute("readonly", "");
                el.style.position = "absolute";
                el.style.left = "-9999px";
                document.body.appendChild(el);
                el.select();
                document.execCommand("copy");
                document.body.removeChild(el);
                this.snackbar.text = "Se copio url para compartir: " + value;
                this.snackbar.color = "success";
                this.snackbar.status = true;
            } else {
                this.snackbar.text = "No se pudo copiar.";
                this.snackbar.color = "error";
                this.snackbar.status = true;
            }
        },
    }
};
</script>

